/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: p4Oo-xLzW7co
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import SideNav from "../../SideNav"; // plasmic-import: pO2ISNagb0tK/component
import ModuleNav from "../../ModuleNav"; // plasmic-import: 4e_vULw2Y0vO/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: mzFiKRs8rOn0/component
import PageLayout from "../../PageLayout"; // plasmic-import: EwKexkGqvtH7/component
import SectionHero from "../../SectionHero"; // plasmic-import: Ol7Sy0qUOFXf/component
import TopNav from "../../TopNav"; // plasmic-import: f3eDTi4F2fC4/component
import ButtonPage from "../../ButtonPage"; // plasmic-import: rG7NQ-o66beM/component
import SectionFooter from "../../SectionFooter"; // plasmic-import: LUEYaWE5GnZw/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: p4Oo-xLzW7co/css
import image30ZI13Qu8AbVw7 from "./images/image30.svg"; // plasmic-import: zI13qu8AbVw7/picture

createPlasmicElementProxy;

export const PlasmicHomepage__VariantProps = new Array();

export const PlasmicHomepage__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <div
            data-plasmic-name={"stikySidenavWrapper"}
            data-plasmic-override={overrides.stikySidenavWrapper}
            className={classNames(projectcss.all, sty.stikySidenavWrapper)}
          >
            <SideNav
              data-plasmic-name={"sideNav"}
              data-plasmic-override={overrides.sideNav}
              backButton={
                <ModuleNav
                  data-plasmic-name={"moduleNav"}
                  data-plasmic-override={overrides.moduleNav}
                  className={classNames("__wab_instance", sty.moduleNav)}
                  navButtonSlot={
                    <ButtonNav
                      data-plasmic-name={"buttonNav"}
                      data-plasmic-override={overrides.buttonNav}
                      className={classNames("__wab_instance", sty.buttonNav)}
                      iconForButton={
                        <PlasmicImg__
                          data-plasmic-name={"img"}
                          data-plasmic-override={overrides.img}
                          alt={""}
                          className={classNames(sty.img)}
                          displayHeight={"100%"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"100%"}
                          loading={"lazy"}
                          src={{
                            src: image30ZI13Qu8AbVw7,
                            fullWidth: 20,
                            fullHeight: 20,
                            aspectRatio: undefined
                          }}
                        />
                      }
                      onClick={async () => {
                        const $steps = {};
                        $steps["goToTop"] = true
                          ? (() => {
                              const actionArgs = { destination: "#top" };
                              return (({ destination }) => {
                                if (
                                  typeof destination === "string" &&
                                  destination.startsWith("#")
                                ) {
                                  document
                                    .getElementById(destination.substr(1))
                                    .scrollIntoView({ behavior: "smooth" });
                                } else {
                                  location.assign(destination);
                                }
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["goToTop"] != null &&
                          typeof $steps["goToTop"] === "object" &&
                          typeof $steps["goToTop"].then === "function"
                        ) {
                          $steps["goToTop"] = await $steps["goToTop"];
                        }
                      }}
                      shape={"fullRounding"}
                    />
                  }
                />
              }
              className={classNames("__wab_instance", sty.sideNav)}
            />
          </div>
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <SectionHero
                  data-plasmic-name={"sectionHero"}
                  data-plasmic-override={overrides.sectionHero}
                  className={classNames("__wab_instance", sty.sectionHero)}
                  colWidth={"medium"}
                  navbar={
                    <TopNav
                      data-plasmic-name={"topNav"}
                      data-plasmic-override={overrides.topNav}
                      className={classNames("__wab_instance", sty.topNav)}
                      pageButtons={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__nb5T6
                            )}
                          >
                            {"["}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__zlzCr
                            )}
                            content={"overview"}
                            isSelected={true}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToNexusHomepage"] = true
                                ? (() => {
                                    const actionArgs = { destination: `/` };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToNexusHomepage"] != null &&
                                typeof $steps["goToNexusHomepage"] ===
                                  "object" &&
                                typeof $steps["goToNexusHomepage"].then ===
                                  "function"
                              ) {
                                $steps["goToNexusHomepage"] =
                                  await $steps["goToNexusHomepage"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__ehrqx
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage___6Hvku
                            )}
                            content={"support"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComSupport"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: "https://o21p.com/support"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComSupport"] != null &&
                                typeof $steps["goToHttpsO21PComSupport"] ===
                                  "object" &&
                                typeof $steps["goToHttpsO21PComSupport"]
                                  .then === "function"
                              ) {
                                $steps["goToHttpsO21PComSupport"] =
                                  await $steps["goToHttpsO21PComSupport"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__zhIb9
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__hgvnz
                            )}
                            content={"sign up free"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComSignup"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: "https://o21p.com/signup"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComSignup"] != null &&
                                typeof $steps["goToHttpsO21PComSignup"] ===
                                  "object" &&
                                typeof $steps["goToHttpsO21PComSignup"].then ===
                                  "function"
                              ) {
                                $steps["goToHttpsO21PComSignup"] =
                                  await $steps["goToHttpsO21PComSignup"];
                              }
                            }}
                            textColor={"brand"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__waL
                            )}
                          >
                            {"]"}
                          </div>
                        </React.Fragment>
                      }
                    />
                  }
                  sectionId={"top"}
                  slot={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__e13Wc
                      )}
                    >
                      {
                        "Whether you\u2019re a solo expert or a full agency, this is the one platform to bring your skills to the people who actually value them."
                      }
                    </div>
                  }
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___5YMxf
                    )}
                  >
                    {"nexus"}
                  </div>
                </SectionHero>
                <SectionFooter
                  data-plasmic-name={"sectionFooter"}
                  data-plasmic-override={overrides.sectionFooter}
                  className={classNames("__wab_instance", sty.sectionFooter)}
                  layout={"withOffset"}
                  sectionId={"footer"}
                />
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          {(hasVariant(globalVariants, "screen", "tablet") ? true : false) ? (
            <div
              data-plasmic-name={"noBudgetSmallScreens"}
              data-plasmic-override={overrides.noBudgetSmallScreens}
              className={classNames(projectcss.all, sty.noBudgetSmallScreens)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__c3RNs
                )}
              >
                {"o21p"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wTu30
                )}
              >
                {
                  "our massive development budget is dedicated to designing and building the platform for larger screens."
                }
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__orLwf
                )}
              >
                {"\u2013 at least 900px wide \u2013"}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "stikySidenavWrapper",
    "sideNav",
    "moduleNav",
    "buttonNav",
    "img",
    "pageLayout",
    "sectionHero",
    "topNav",
    "sectionFooter",
    "noBudgetSmallScreens"
  ],

  stikySidenavWrapper: [
    "stikySidenavWrapper",
    "sideNav",
    "moduleNav",
    "buttonNav",
    "img"
  ],

  sideNav: ["sideNav", "moduleNav", "buttonNav", "img"],
  moduleNav: ["moduleNav", "buttonNav", "img"],
  buttonNav: ["buttonNav", "img"],
  img: ["img"],
  pageLayout: ["pageLayout", "sectionHero", "topNav", "sectionFooter"],
  sectionHero: ["sectionHero", "topNav"],
  topNav: ["topNav"],
  sectionFooter: ["sectionFooter"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    stikySidenavWrapper: makeNodeComponent("stikySidenavWrapper"),
    sideNav: makeNodeComponent("sideNav"),
    moduleNav: makeNodeComponent("moduleNav"),
    buttonNav: makeNodeComponent("buttonNav"),
    img: makeNodeComponent("img"),
    pageLayout: makeNodeComponent("pageLayout"),
    sectionHero: makeNodeComponent("sectionHero"),
    topNav: makeNodeComponent("topNav"),
    sectionFooter: makeNodeComponent("sectionFooter"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "o21p nexus",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
